import gql from 'graphql-tag'

export const AchievementsFieldsFragment = gql`
  fragment AchievementsFields on Achievements {
    infantToddlerExperience
    preschoolExperience
    schoolExperience
    educationLevel
    otherEducationItems {
      name
      level
    }
    specialCertificationItems {
      name
    }
  }
`
